var React = require('react');

function Sofort (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M28 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H28C30.2091 24 32 22.2091 32 20V4C32 1.79086 30.2091 0 28 0Z","fill":"#F4B6C7","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.25 17.25H10V6.75H12.25V17.25ZM12.6667 12.0222C14.6631 11.039 15.9534 9.05237 15.9999 6.75088H18.3632C18.3311 8.93615 17.4292 10.9634 15.8415 12.4672L18.9999 17.25H15.9999L12.6667 12.0222Z","fill":"black","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19 15.7501C19 16.5784 19.6716 17.25 20.5001 17.25C21.3284 17.25 22 16.5784 22 15.7501C22 14.9216 21.3284 14.25 20.5001 14.25C19.6716 14.25 19 14.9216 19 15.7501Z","fill":"black","key":2})]);
}

Sofort.defaultProps = {"width":"32","height":"24","viewBox":"0 0 32 24","fill":"none"};

module.exports = Sofort;

Sofort.default = Sofort;
